// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e4021c42","other":"c7e30c47","pencil":"a85450ce"};